import { render, staticRenderFns } from "./product.vue?vue&type=template&id=2576a3ef&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=2576a3ef&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576a3ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2576a3ef')) {
      api.createRecord('2576a3ef', component.options)
    } else {
      api.reload('2576a3ef', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=2576a3ef&scoped=true", function () {
      api.rerender('2576a3ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintenance/service/product.vue"
export default component.exports